import { useCallback, useEffect, useState } from 'react'
import { DsGmeetCalendarEvent, listUpcoming } from '../api/dsGmeetApi'

export function useUpcomingCalls(userId: string) {
    const [items, setItems] = useState<DsGmeetCalendarEvent[]>([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const refetch = useCallback(async () => {
        if (!userId) return
        setLoading(true)
        setError('')
        try {
            setItems(await listUpcoming(userId))
        } catch (err) {
            setError(err instanceof Error ? err.message : String(err))
        } finally {
            setLoading(false)
        }
    }, [userId])

    useEffect(() => {
        void refetch()
    }, [refetch])

    return { items, loading, error, refetch }
}
